module.exports = __webpack_public_path__ + "img/ask.7bd12bd4.png";